import { useState, useContext } from 'react';
import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';
import { MODAL_ID } from './constants';

/**
 * Used for sharing state around the application for the job locked modal
 * @returns {{locked: boolean, showModal: showModal}}
 */
export default function useJobLockedModal() {
  const [locked, setLocked] = useState(false);
  const { showModal: showAppModal } = useContext(ModalsWrapperContext);

  const showModal = (currentlyLocked = false) => {
    setLocked(currentlyLocked);
    showAppModal(MODAL_ID);
  };

  return {
    locked,
    showModal,
  };
}
